import {Milestone, UserMilestones} from "./MilestoneService";
import {IsoDate} from "../../pseudo-types/DateTypes";
import {Optional} from "../../js/util/Optional";

export class Milestones {
    public constructor(private userMilestones: UserMilestones) {
    }

    public hasCompleted(milestone: Milestone): boolean {
        return this.userMilestones[milestone] != null;
    }

    public completedOn(milestone: Milestone): Optional<IsoDate> {
        return Optional.of(this.userMilestones[milestone]);
    }
}
